module.exports = __webpack_public_path__ + "img/icon-aws.dc1b49cc.svg";